import { render, staticRenderFns } from "./referansbirlestir.vue?vue&type=template&id=2313c748"
import script from "./referansbirlestir.vue?vue&type=script&lang=js"
export * from "./referansbirlestir.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports